// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { render, createElement } from '@plesk/ui-library';
import App from './App';

module.exports = container => {
    render(<App />, container);
};



// WEBPACK FOOTER //
// ./app/repair/index.js